import { render } from "./LoadingPlaceholder2.vue?vue&type=template&id=e5a7e86c&scoped=true"
import script from "./LoadingPlaceholder2.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder2.vue?vue&type=script&lang=js"

import "./LoadingPlaceholder2.vue?vue&type=style&index=0&id=e5a7e86c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e5a7e86c"

export default script